/**
 * Game registry. More games get added later, so the shell picks from a list
 * from day one rather than hard-coding volleyball into the lobby.
 *
 * Everything except volley is a stub: listed, visibly not ready, unselectable.
 */
export interface GameDef {
  id: string;
  title: string;
  tagline: string;
  /** Team sizes the game supports. */
  teamSizes: number[];
  available: boolean;
}

export const GAMES: readonly GameDef[] = [
  {
    id: 'volley',
    title: 'Blob Volley',
    tagline: 'Three touches, then it is dead',
    teamSizes: [1, 2, 3],
    available: true,
  },
  {
    id: 'sumo',
    title: 'Blob Sumo',
    tagline: 'Not built yet',
    teamSizes: [1, 2],
    available: false,
  },
  {
    id: 'keepie',
    title: 'Keepie Uppie',
    tagline: 'Not built yet',
    teamSizes: [1, 2, 3],
    available: false,
  },
];

export const DEFAULT_GAME = 'volley';

export function findGame(id: string): GameDef {
  return GAMES.find((g) => g.id === id) ?? GAMES[0]!;
}
